import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { EditCommoditiesForm } from "web_myplann/Portfolio/Pages/CommoditiesEdit/EditCommoditiesForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditCommoditiesPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.Commodities}
			title={(portfolio) =>
				t(Resources.Portfolio.EditPortfolio.title, {
					type: getPortfolioTitle(portfolio, t),
				})
			}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditCommoditiesForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
